<style scoped>
    @import url("../../styles/dashMain/dashMain.scss");
</style>

<template>
    <!--<div class="box_dashMain" v-if="!$store.state.flagMenuSup"
    :style="{
    backgroundImage:'url(' + require('../../assets/city_ia_t1.webp') + ')',
    backgroundSize: 'cover', // cover contain
    backgroundPosition: 'center' // top center
    }">-->
    <div class="box_dashMain" v-if="!$store.state.flagMenuSup">

        <LoginPageTipoA v-if="!$store.state.flagLogadoDash"
        @openPainel="resultLogin($event)"
        />

        <PainelDashMain v-if="$store.state.flagLogadoDash"
        @closePainel="logOff()"
        :objUser="$store.state.contentUser"
        :z0="z0"
        :cart_id="cart_id"
        />

    </div>
</template>

<script>
import LoginPageTipoA from './LoginPageTipoA'
import PainelDashMain from './PainelDashMain'

export default {

    components:{LoginPageTipoA, PainelDashMain},

    data() {
        return {
            //
            //flagLoginDashMain:true, // tornou-se variável global em 10/09/2024.
            //objUserMain:{}, // tornou-se variável global em 10/09/2024. (contentUser)

            z0:null,
            cart_id:null,

            backCart:false, // indica retorna ao elemento chamador (loja) 23/03/2026
        }
    },

    methods:{
        //
        resultLogin(objUser) { 

            //console.log('[father] objUser: ',objUser)
            //this.objUserMain = objUser
            this.$store.state.contentUser = objUser
            //console.log('objUserMain: ',this.objUserMain)
            this.$store.state.flagLogadoDash = true // habilitar painel inicial do usuário.
            //console.log('[father][resultLogin] END')
        },
        logOff() { 
            // -- desabilitar painel inicial do usuário.
            
            this.$store.state.flagLogadoDash = false
            this.$store.state.contentUser = {} // reset

            let tox = ''
            var update_creden = {'flagLogadoDash':false}
            localStorage.setItem('creden', JSON.stringify(update_creden))
            localStorage.setItem('contentUser', JSON.stringify({}))
            localStorage.setItem('tokenx', JSON.stringify(tox))
        },
        cartVerif(z0) {

            if (z0 == 'cnex') {

                this.$store.state.flagLogadoDash = true // abrir dash vazio.
            }
        },

        goToReactCheckout() {
            const params = new URLSearchParams({
                email: this.email ?? '',
                backCart: 'true',
            })

            window.location.href = `https://www.upinc.pt/checkout?${params.toString()}`
        },
    },

    created() {
        window.scrollTo(0,0)

        this.cartId = this.$route.query.cart_id
        this.z0 = this.$route.query.z0
        //console.log('cartId: ',this.cartId)
        //console.log('z0: ',this.z0)

        this.backCart = this.$route.query.backCart
        console.log('type backCart: ', Object.prototype.toString.call(this.backCart))

        // -- verif se novo, senão, login obrigatório.
        this.cartVerif(this.z0)

        // -- STORAGE
        var creden = JSON.parse(localStorage.getItem('creden'))
        var contentUser = JSON.parse(localStorage.getItem('contentUser'))
        let tox = JSON.parse(localStorage.getItem('tokenx'))

        //console.log(creden)
        //console.log('contentUser: ',contentUser)
        //console.log('tox: ',tox)

        if (creden != null) {
            this.$store.state.flagLogadoDash = creden.flagLogadoDash
            this.$store.state.contentUser = contentUser
            this.$store.state.tox = tox

            if (this.$store.state.flagLogadoDash && this.backCart) { this.goToReactCheckout() }

            //console.log('flag login está alocada localmente [dashmain]')
        }
    }
}
</script>